import React, { useState } from "react";
import { LayoutGrid, Feather, Box, Sparkles, Leaf, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
const categories = [{
  title: "Home Organization",
  icon: LayoutGrid,
  href: "/JournalPage",
  color: "bg-secondary",
  description: "Streamline your spaces with functional systems"
}, {
  title: "Decluttering",
  icon: Feather,
  href: "/JournalPage",
  color: "bg-chart-1/20",
  description: "Let go of the unnecessary and find mental clarity"
}, {
  title: "Storage Solutions",
  icon: Box,
  href: "/ToolkitPage",
  color: "bg-secondary",
  description: "Smart ways to stow your belongings beautifully"
}, {
  title: "Cleaning Routines",
  icon: Sparkles,
  href: "/JournalPage",
  color: "bg-chart-1/20",
  description: "Keep your environment fresh and tidy effortlessly"
}, {
  title: "Minimalist Living",
  icon: Leaf,
  href: "/PhilosophyPage",
  color: "bg-secondary",
  description: "Live more with less by focusing on what matters"
}];
export default function CuratedCollections() {
  const [activeTab, setActiveTab] = useState(categories[0].title);
  const activeCategory = categories.find(c => c.title === activeTab) || categories[0];
  return <section id="curated-collections" className="dark bg-background text-foreground py-20 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center space-y-4">
          <h2 className="text-3xl md:text-4xl font-serif font-medium tracking-tight">
            Curated Collections
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto font-light">
            Explore our most popular categories designed to help you create a calm, functional, and beautiful home.
          </p>
        </div>

        <div className="flex flex-col items-center">
          {}
          <div className="flex flex-wrap justify-center gap-2 md:gap-8 mb-12 border-b border-border/20 w-full max-w-4xl">
            {categories.map((category, i) => <button key={category.title} data-index={i} onClick={() => setActiveTab(category.title)} className={cn("px-2 md:px-4 pb-4 text-[10px] md:text-xs uppercase tracking-[0.2em] transition-all duration-300 border-b-2 font-sans cursor-pointer outline-none", activeTab === category.title ? "border-chart-1 text-foreground" : "border-transparent text-muted-foreground hover:text-foreground/70")}>
                {category.title}
              </button>)}
          </div>

          {}
          <div className="w-full max-w-xl transition-all duration-500 ease-in-out">
            <Link to={activeCategory.href} className="group block h-full">
              <Card className={cn("h-full border-none transition-all duration-300 ease-out shadow-sm", "hover:shadow-xl hover:scale-[1.01] hover:brightness-95", activeCategory.color)}>
                <CardContent className="flex flex-col items-center justify-center text-center p-12 h-full gap-6">
                  <div className="p-4 rounded-full bg-background/50 backdrop-blur-sm shadow-sm group-hover:scale-110 transition-transform duration-500">
                    <activeCategory.icon strokeWidth={1.2} className="w-12 h-12 text-foreground/80" />
                  </div>
                  
                  <div className="space-y-4">
                    <div className="space-y-2">
                      <h3 className="font-serif text-2xl md:text-3xl font-medium text-foreground">
                        {activeCategory.title}
                      </h3>
                      <p className="text-muted-foreground font-light max-w-xs mx-auto text-sm leading-relaxed">
                        {activeCategory.description}
                      </p>
                    </div>
                    
                    <div className="pt-2">
                      <p className="text-[10px] text-muted-foreground uppercase tracking-[0.25em] flex items-center justify-center gap-2 transition-all duration-300 group-hover:text-foreground group-hover:translate-x-1">
                        Explore Collection <ArrowRight className="w-3 h-3" />
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}